import { useEffect, useState } from "react";

// Thin scroll-progress bar at the very top — as on the live homepage.
export default function ScrollProgress() {
  const [width, setWidth] = useState(0);
  useEffect(() => {
    const onScroll = () => {
      const doc = document.documentElement;
      const max = doc.scrollHeight - window.innerHeight;
      setWidth(max > 0 ? (window.scrollY / max) * 100 : 0);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    onScroll();
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, []);
  return (
    <div className="fixed left-0 top-0 z-[70] h-[3px] w-full" aria-hidden="true">
      <div className="h-full bg-brand" style={{ width: `${width}%` }} data-testid="scroll-progress" />
    </div>
  );
}